(function () {
  const DESKTOP_QUERY = '(min-width: 768px)';
  const activated = { desktop: false, mobile: false };

  function activateTemplates(viewport) {
    if (activated[viewport]) return;
    activated[viewport] = true;
    const selector = 'template[data-img-banner-2-bg="' + viewport + '"]';
    const templates = document.querySelectorAll(selector);
    for (let i = 0; i < templates.length; i++) {
      const tpl = templates[i];
      const parent = tpl.parentNode;
      if (!parent) continue;
      parent.appendChild(tpl.content.cloneNode(true));
      tpl.remove();
    }
  }

  function init() {
    const mq = window.matchMedia(DESKTOP_QUERY);
    activateTemplates(mq.matches ? 'desktop' : 'mobile');

    const onChange = function () {
      activateTemplates(mq.matches ? 'desktop' : 'mobile');
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
